import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import Loading from 'src/components/Loading';
import { AutomaticWithdrawalPendingRow } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/WithdrawalPendingRow/WithdrawalPendingRow';
import {
    TabWithdrawalsWrapper,
    NoItemInfo,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/AutomaticWithdrawalsPending/AutomaticWithdrawalsPending.style';
import {
    GridHeaderRow,
    GridItem,
    GridBody,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/GridRow.style';

const renderList = (list: Array<number>): Array<React.ReactNode> => {
    const elements: Array<React.ReactNode> = [];

    for (const withdrawalId of list) {
        elements.push(
            <AutomaticWithdrawalPendingRow
                key={withdrawalId}
                withdrawalId={withdrawalId}
            />
        );
    }

    return elements;
};

interface TablePropsType {
    withdrawalIdList: Array<number> | null;
}

export const AutomaticWithdrawalsTable = observer('AutomaticWithdrawals', (propsIn: TablePropsType) => {
    const { withdrawalIdList } = propsIn;
    if (withdrawalIdList === null) {
        return (
            <Loading
                message='Loading...'
                active={true}
            />
        );
    }

    return (
        <>
            {renderList.length === 0 ? (
                <NoItemInfo>There are currently no pending automatic withdrawal requests</NoItemInfo>
            ) : (
                <>
                    <GridHeaderRow>
                        <GridItem>Account Number</GridItem>
                        <GridItem>Card</GridItem>
                        <GridItem>Name</GridItem>
                        <GridItem>Reason to Reject</GridItem>
                        <GridItem>Amount to Approve</GridItem>
                    </GridHeaderRow>
                    <GridBody>{renderList(withdrawalIdList)}</GridBody>
                </>
            )}
        </>
    );
});

export const AutomaticWithdrawalsPending = observer('AutomaticWithdrawalsPending', () => {
    const { automaticWithdrawalState } = useAppStateContext();
    const { withdrawalIdList } = automaticWithdrawalState;
    return (
        <TabWithdrawalsWrapper>
            <AutomaticWithdrawalsTable withdrawalIdList={withdrawalIdList} />
        </TabWithdrawalsWrapper>
    );
});
